import Options from "./Options";

const GeneralOptions = (props) => {
  const options = [

    {
      name: "1️⃣ Explore Courses 📚",
      handler: props.actionProvider.handleProductOverview,
      id: 1
    },
    {
      name: "2️⃣ Career Opportunities 💼",
      handler: props.actionProvider.handleFeatures,
      id: 2
    },
    {
      name: "3️⃣ About Intelle-Sphere ℹ️",
      handler: props.actionProvider.handleForSchools,
      id: 3
    },
    {
      name: "4️⃣ 📅 Book a Free Consultation",
      handler: props.actionProvider.handleBookDemo,
      id: 4
    },
  
    {
      name: "Support",
      handler: props.actionProvider.handleContact,
      id: 5
    },
 
 
  ];
  return <Options options={options} title="Options" {...props} />;
};

export default GeneralOptions;
